import {SignDocumentStep} from '../types/SignDocumentStep';

export const DEFAULT_SIGNING_STEP: SignDocumentStep = 'modeSelect';
